// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.costSavingSettingsBodyRow__wYNvG:hover {
  background: var(--tables-primary-row-surface-hover);
}

.costSavingLocationSettingsBodyRow__bXEt4 {
  background: var(--tables-secondary-row-sub-title-surface);
}
.costSavingLocationSettingsBodyRow__bXEt4 .name__nh0E1 {
  color: var(--tables-primary-row-text-main);
  font-size: 14px;
  font-weight: 400;
  text-transform: none;
}
@media (max-width: 1024px) {
  .costSavingLocationSettingsBodyRow__bXEt4 .name__nh0E1 {
    font-size: 12px;
  }
}

.arrowWrapper__Q234v {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-right: 10px;
}

.expandArrow__KkkGN {
  transform: rotate(-deg);
}

.facilityColumn__V99oK {
  max-width: 400px;
}
@media (max-width: 1280px) {
  .facilityColumn__V99oK {
    max-width: 300px;
  }
}
@media (max-width: 900px) {
  .facilityColumn__V99oK {
    max-width: 200px;
  }
}

.hideArrow__v8Hcu {
  visibility: hidden;
}`, "",{"version":3,"sources":["webpack://./../src/pages/MultiplicationFactors/components/CostSavingCalculationItem/style.module.scss"],"names":[],"mappings":"AA2EE;EACE,mDAAA;AA1EJ;;AA8EA;EACE,yDAAA;AA3EF;AA4EE;EACE,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AA1EJ;AA4EI;EANF;IAOI,eAAA;EAzEJ;AACF;;AA6EA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AA1EF;;AA6EA;EACE,uBAAA;AA1EF;;AA6EA;EACE,gBAAA;AA1EF;AA4EE;EAHF;IAII,gBAAA;EAzEF;AACF;AA2EE;EAPF;IAQI,gBAAA;EAxEF;AACF;;AA2EA;EACE,kBAAA;AAxEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.costSavingSettingsBodyRow {\n  &:hover {\n    background: var(--tables-primary-row-surface-hover);\n  }\n}\n\n.costSavingLocationSettingsBodyRow {\n  background: var(--tables-secondary-row-sub-title-surface);\n  .name {\n    color: var(--tables-primary-row-text-main);\n    font-size: 14px;\n    font-weight: 400;\n    text-transform: none;\n\n    @media (max-width: 1024px) {\n      font-size: 12px;\n    }\n  }\n}\n\n.arrowWrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  margin-right: 10px;\n}\n\n.expandArrow {\n  transform: rotate(-deg);\n}\n\n.facilityColumn {\n  max-width: 400px;\n\n  @media (max-width: 1280px) {\n    max-width: 300px;\n  }\n\n  @media (max-width: 900px) {\n    max-width: 200px;\n  }\n}\n\n.hideArrow {\n  visibility: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"costSavingSettingsBodyRow": `costSavingSettingsBodyRow__wYNvG`,
	"costSavingLocationSettingsBodyRow": `costSavingLocationSettingsBodyRow__bXEt4`,
	"name": `name__nh0E1`,
	"arrowWrapper": `arrowWrapper__Q234v`,
	"expandArrow": `expandArrow__KkkGN`,
	"facilityColumn": `facilityColumn__V99oK`,
	"hideArrow": `hideArrow__v8Hcu`
};
module.exports = ___CSS_LOADER_EXPORT___;
